import { Component, ChangeDetectionStrategy, AfterViewInit, OnDestroy, ComponentRef, Injector, ViewContainerRef, ɵcreateInjector as createInjector } from '@angular/core'
import { RxStateComponent } from '@alliance/shared/models'
import { catchError, filter, from, map, Observable, of } from 'rxjs'
import { CurrentUserApiService } from '@alliance/ats/users/api'
import { UserScope } from '@alliance/ats/graphql-client'

@Component({
  selector: 'lib-lazy-manager-panel',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LazyManagerPanelComponent extends RxStateComponent<object> implements AfterViewInit, OnDestroy {
  private componentRef: ComponentRef<unknown> | undefined

  public constructor(private currentUserApiService: CurrentUserApiService, private injector: Injector, private viewContainerRef: ViewContainerRef) {
    super()
    this.initState({
      shouldRender: this.currentUserApiService.getUserHasRightTo$(UserScope.ProjectCreation)
    })
  }

  public ngAfterViewInit(): void {
    this.hold(this.render$().pipe(filter(Boolean)), componentRef => {
      this.componentRef = componentRef
    })
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy()

    this.clearTemplate()
  }

  private render$(): Observable<ComponentRef<unknown> | null> {
    return from(import('../../manager')).pipe(
      map(({ ManagerModule }) => {
        const injector = createInjector(ManagerModule, this.injector)
        const module = injector.get(ManagerModule)

        return this.viewContainerRef ? module.render(this.viewContainerRef) : null
      }),
      catchError(() => of(null))
    )
  }

  private clearTemplate(): void {
    this.componentRef?.destroy()
    this.viewContainerRef?.clear()
  }
}
